export const localeCalendar = {
  title: 'Calendar',
  today: 'Today',
  month: 'Month',
  year: 'Year',
  am: 'AM',
  pm: 'PM',
  dateTimeFormat: 'MM/dd/yyyy w hh:mm',
  dateFormat: 'yyyy/MM/dd w',
  noChoose: 'No Choose',
  week: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  clear: 'Clear',
  selectTime: 'Select Time',
  selectStartTime: 'Select Start Time',
  selectEndTime: 'Select End Time',
  start: 'Start',
  end: 'End',
  begin: 'Start',
  over: 'End',
  // eslint-disable-next-line @typescript-eslint/camelcase
  begin_over: 'S/E',
  confirm: 'Confirm',
  monthTitle: 'yyyy/MM',
  loadPrevMonth: 'Load Prev Month',
  yesterday: 'Yesterday',
  lastWeek: 'Last Week',
  lastMonth: 'Last Month'
};
